import { FilterEntryWithoutLabel } from "@/common/contracts/ads.contracts";
import { useCallback, useEffect, useState } from "react";

export const useFiltering = <T extends string>(
  initialFiltering?: Partial<Record<T, FilterEntryWithoutLabel>>
) => {
  const [filtering, setFiltering] = useState(initialFiltering);

  useEffect(() => {
    setFiltering(initialFiltering);
  }, [initialFiltering]);

  const onToggleFilter = useCallback((filter: T) => {
    setFiltering(prev => ({
      ...prev,
      [filter]: {
        active: !prev?.[filter]?.active,
      },
    }));
  }, []);

  return {
    filtering,
    onToggleFilter,
  };
};
